import { jsx as _jsx } from "react/jsx-runtime";
import Input from "./Input";
/**
 * A password input with a show/hide toggle button.
 * This is a wrapper around Input component with type="password".
 *
 * @export
 * @example
 * ```tsx
 * <PasswordInput
 *   value={password}
 *   onChange={setPassword}
 *   placeholder="Enter password"
 * />
 * ```
 *
 * @example
 * ```tsx
 * // Recommended: Use Input directly
 * <Input
 *   type="password"
 *   value={password}
 *   onChange={setPassword}
 *   placeholder="Enter password"
 * />
 * ```
 */
const PasswordInput = (props) => {
    return _jsx(Input, Object.assign({}, props, { type: "password" }));
};
export default PasswordInput;
